import { ICellRendererParams } from 'ag-grid-community'
import * as validator from '../../../../lib/validator'
import Tooltip from '../../../../../../../components/tooltips/Tooltip'
import { FunctionProperty } from '../../../../../../../../lib/commons/appFunction'
import { FloatingEditableIcon } from './index'
import { StaleIndicatorIcon } from '../../../../../../../components/icons/StaleIndicatorIcon'

interface Props extends ICellRendererParams {
  tooltip: (params: ICellRendererParams) => string | undefined
  stale?: (params: ICellRendererParams) => boolean
  staleMessage?: string
  // When true, render StaleIndicatorIcon before the text in DOM.
  // For RTL cells (e.g. path columns), this makes the icon appear at the right end visually.
  staleIconAtStart?: boolean
}

export default function CellRenderer(params: Props) {
  const value =
    !params.valueFormatted && params.valueFormatted !== ''
      ? !params.value && params.value !== 0
        ? ''
        : params.value
      : params.valueFormatted
  const message = validate(value, params)
  const tooltip = params.tooltip ? params.tooltip(params) : undefined
  const isStale = !!params.stale?.(params)
  const staleIcon = isStale && params.staleMessage && (
    <StaleIndicatorIcon message={params.staleMessage} />
  )

  return (
    <Tooltip message={message || tooltip}>
      <div
        id={`column-${params.column?.getColId()}-${params.node?.rowIndex}`}
        className="sevend-ag-cell"
        style={{
          backgroundColor: !!message ? validator.inputErrorColor : undefined,
        }}
      >
        {params.staleIconAtStart && staleIcon}
        <p>{value}</p>
        {!params.staleIconAtStart && staleIcon}
        <FloatingEditableIcon {...params} />
      </div>
    </Tooltip>
  )
}

const validate = (value: string, params: ICellRendererParams) => {
  // Flat list rows can be grouped and are read only
  if (!params.colDef) return ''
  const { cellRendererParams } = params.colDef
  if (cellRendererParams && cellRendererParams.uiMeta) {
    const errorMessage = validator.validate(
      value,
      params.data,
      cellRendererParams.uiMeta,
      cellRendererParams.viewMeta,
      params.api
    )
    if (errorMessage) return errorMessage

    const functionProps: FunctionProperty = cellRendererParams.uiMeta
    return params.data.errorMessages &&
      functionProps.externalId in params.data.errorMessages
      ? params.data.errorMessages[functionProps.externalId] || ''
      : ''
  }
  return ''
}
